<script setup lang="ts">
import { useHead, useSeoMeta } from "#imports";
import { useI18n } from "vue-i18n";

const { locale } = useI18n();

useHead({
  htmlAttrs: {
    lang: locale.value,
  },
  meta: [
    {
      name: "google-site-verification",
      content: process.env.VITE_SEARCH_CONSOLE_CODE, // Ajoute ce code
    },
  ],
});
useSeoMeta({
  ogImage: import.meta.env.VITE_OLD_BASE_URL + "/favicon.ico",
  ogImageAlt: "Tutassur",
  ogImageUrl: import.meta.env.VITE_OLD_BASE_URL + "/favicon.ico",
  twitterImage: import.meta.env.VITE_OLD_BASE_URL + "/favicon.ico",
});
</script>

<template>
  <NuxtLayout>
    <NuxtPage />
  </NuxtLayout>
</template>
